import axios from "@/libs/api.request";
import { getToken } from "@/libs/util";
export const getList = data => {
  return axios.request({
    url: "/tagService/index",
    method: "get",
    data
  });
};

export const save = data => {
  return axios.request({
    url: "/tagService/save",
    method: "post",
    data
  });
};


export const del = id => {
  return axios.request({
    url: "/tagService/delete/"+id,
    method: "post",
  });
};

export const delFile = id => {
  return axios.request({
    url: "/tagService/delSrc/"+id,
    method: "post",
  });
};

export const uploadFile = data => {
  return axios.request({
    url: "/tagService/upload",
    method: "post",
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: getToken()
    },
    data: data
  });
};

export const excel = (data)=>{
	return axios.request({
	  url: `/tagService/excel`,
	  method: 'POST',
		data,
		headers: {
		  "Content-Type": "multipart/form-data",
		  Authorization: getToken()
		}
	})
}

export const src = (data)=>{
	return axios.request({
	  url: `/tagService/src`,
	  method: 'POST',
		data,
	})
}

export const download = (data)=>{
	return axios.request({
	  url: `/tagService/download`,
	  method: 'POST',
		data,
	})
}

export const upload = (data)=>{
	return axios.request({
	  url: `/tagService/upload`,
	  method: 'POST',
		data,
		headers: {
		  "Content-Type": "multipart/form-data",
		  Authorization: getToken()
		}
	})
}

export const getDunhuangData = (data) => {
  return axios.request({
    url: `/common/dhDate`,
    method: 'POST',
    data,
  })
}

export const markResult = data => {
  return axios.request({
    url: `/tagService/markResult`,
    method: 'POST',
    data,
  })
}
